import React from 'react';
import { redirectToProdiktLogin } from '../../utils/authUtils';

interface ProdiktLoginButtonProps {
  className?: string;
}

/**
 * Reusable Prodikt login button component
 * Opens Prodikt homepage in a new tab for user authentication
 */
const ProdiktLoginButton: React.FC<ProdiktLoginButtonProps> = ({
  className = 'px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors',
}) => {
  return (
    <button onClick={redirectToProdiktLogin} className={className}>
      Login with Prodikt
    </button>
  );
};

export default ProdiktLoginButton;
